import Scrollbar from 'smooth-scrollbar'
        import BaseController from './BaseController'

        export default class PlanningController extends BaseController {

    init() {
        this.letterByLetter('.planning__title', 1)

        this.$ =
                {
                    header: document.querySelector('.header'),
                    scrollbar: document.querySelector('#my-scrollbar'),
                    popInBackground: document.querySelector('.pop-in__background'),
                    button: document.querySelector('.mainButton--svgBorder'),
                }

        this.timeline =
                {
                    //detail: new TimelineMax({ paused: true })
                    // .from('.details__box', .3, { display: 'none' }, 'popIn')
                    //.fromTo('.details__box', .3, { y: '-40%', x: '-50%', autoAlpha: 0, ease: Power1.easeOut }, { y: '-50%', x: '-50%', autoAlpha: 1 }, 'popIn')
                    // .to('.details__box', 0, { y: '-50%', x: '-50%' })
                    //.from(this.$.popInBackground, .3, { opacity: 0, display: 'none' , ease: Power1.easeOut }, 'popIn')
                }

        this.options =
                {
                    damping: 0.1,
                    thumbMinSize: 20
                }

        this.boxOpen = false

        // this.scrollbar = Scrollbar.init(this.$.scrollbar, this.options)

        this.listeners()
        this.initScrollbar()
        this.filterScroll()
        
        this.revealAnimation()
    }
    
    revealAnimation() {
        if (document.querySelector('.planning__btn')) {
            
            TweenMax.from(document.querySelector('.planning__btn'), .8, {
                    opacity: 0,
                    ease: Power1.easeOut,
                    delay: 1.3
                }
            )
            
            TweenMax.to(this.$.button.querySelector('svg'), .8, {
                    strokeDashoffset: 0,
                    ease: Power1.easeOut,
                    delay: 1.5
                }
            )
            
        }
    }

    letterByLetter(_$elem, delay) {
        const $elem = document.querySelector(_$elem)
        const letters = new SplitText($elem, {type: 'chars'})
        TweenMax.staggerFrom(letters.chars, .5, {y: '100%', ease: Power1.easeOut, delay}, .04)
    }

    listeners() {
        const $events = document.querySelectorAll('.planning__box')

        for (const $event of $events) {
            $event.addEventListener('click', () => {
                this.showPlanningDetails($details)
            })
        }

        const $details = document.querySelector('.details__box')
        const $closeButton = $details.querySelector('.pop-in__cross')
        const $background = document.querySelector('.pop-in__background')

        $background.addEventListener('click', (e) => {
            //if (e.target == $background) this.hidePlanningDetails($details)
        })

        //$closeButton.addEventListener('click', () => {
            //this.hidePlanningDetails($details)
        //})

        window.addEventListener('keydown', (e) => {
            //if (e.keyCode == 27) this.hidePlanningDetails($details)
        })

        /*  this.scrollbar.addListener((event) => {
         // Set delta.x or delta.y if isMobile or not
         this.deltaY = event.offset.y
         
         this.$.header.style.transform = `translateY(${-this.deltaY}px)`
         })      */

        document.addEventListener('click', (event) => {
            for (let i = 0;
            i < event.path.length; i++) {
                //if (event.path[i] !== document.querySelector('.details__box') && this.boxOpen) this.hidePlanningDetails($details)
            }
        })
    }

    filterScroll() {
        const $filterScrollbars = document.querySelectorAll('.planning__categories__scrollbar')
        for (const $filterScrollbar of $filterScrollbars) {
            const filterScrollbar = Scrollbar.init($filterScrollbar, {damping: 1, alwaysShowTracks: true})
        }
    }

    showPlanningDetails($details) {
//        setTimeout(() => {
//             this.boxOpen = true
//        }, 500)
//        this.timeline.detail.play()
    }

    hidePlanningDetails($details) {
        this.boxOpen = false
        this.timeline.detail.reverse()
    }
}